import { useEffect, useState, useMemo } from 'react'
import UserNavigationService from 'services/UserNavigationService'
import UserService from 'services/UserService';
import ClientService from 'services/ClientService';
import Endpoints from 'constants/Endpoints';
import RouterPath from 'libs/RouterPath';
import OAuthService from 'services/OAuthService';

export default (
	authorizeCounter,
	params = {},
	setRedirectFunc,
	setRedirectWithoutHistoryFunc,
	history,
	location
) => {
	const [isNewToken, setIsNewToken] = useState(false);

	const [refresh, setRefresh] = useState(null);
	const refreshState = () => setRefresh(Math.random())
	const firstLoad = refresh === null;

	const [canRender, setCanRender] = useState(false)
	const [isTokenValid, setIsTokenValid] = useState(false)

	const authorize = JSON.parse(localStorage.getItem("authorize"))
	const { code, state } = params;

	const token = useMemo(() => {
		if (authorize) return authorize.access_token;
		return undefined;
	}, [authorize])

	useEffect(() => {
		if (firstLoad) {
			setRedirectFunc(history.push);
			setRedirectWithoutHistoryFunc(history.replace)
			refreshState();
			return;
		}

		if (isTokenValid) return;

		(async (token, code, state, isNewToken) => {
			if (!token) {
				if (!code) {
					// no token and no code
					// get code from server
					if (!state) {
						if (location.pathname === RouterPath.BASE) {
							state = window.btoa(RouterPath.MY_PROCEDURE);
						} else {
							state = window.btoa(location.pathname + location.search);
						}
					}
					window.location.href = Endpoints.oauth.AUTHORIZE(state)
				} else {
					// no token but have code
					// get token
					const tokenGranted = await OAuthService.getToken(code);
					if (tokenGranted)
						setIsNewToken(true);
				}
			} else {
				setIsTokenValid(true);
				if (isNewToken) {
					// is new token, can get initialize values
					RouterPath.redirect(window.atob(state))
				}
			}
		})(token, code, state, isNewToken);
	
		// eslint-disable-next-line
	}, [token, code, firstLoad, isNewToken])

	// get initialize values
	useEffect(() => {
		if (isTokenValid) {
			(async () => {
				await ClientService.clientColors().then(settings => {
					if (!!settings.customTabName)
						document.getElementById('page_title').text = escapeHtml(settings.customTabName);
					if (!!settings.customFaviconPath)
						document.getElementById('favicon_link').href = settings.customFaviconPath;
				});
				await UserNavigationService.get();
				await UserService.data();
				await UserService.profile();
				await UserService.sessionTime();
				await ClientService.logo();
				setCanRender(true);
			})();
		}
	}, [isTokenValid])

	const escapeHtml = value => {
		return value
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#039;");
	}

	// open or close aside menu
	useEffect(() => {
		RouterPath.setMenuOpenOnPath();
	}, [])

	return canRender;
}